import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/serviceGroupSettings';

export async function getOne(id: string, signal: AbortSignal) {
    const url = `${baseUrl}/${id}`;

    return await fetchJson({ method: 'GET', signal, url });
}
